import { sendPost } from '../../http.js'
const commons = (url, params, fn) => {
  return sendPost(url, params)
    .then((res) => {
      fn(res)
      //console.log('成功')
    }).catch((err) => {
		throw Error(err)
      fn(err)
      //console.log('失败')
  })
}
const api = {
	'showlist': '/user/user/showlist',
	'showinfo': '/user/user/showinfo',
	'createdshow': '/user/user/createdshow',
	'showrecall': '/user/user/showrecall',
	'grouplist': '/user/user/product/group/list',
	'addgroup': '/user/user/product/group',
	'groupsort': '/user/user/product/group/sort',
	'groupremove': '/user/user/product/group/remove',
}

export default {
	 showlist(params, fn) {
	 	commons(api.showlist, params, fn)
	 },
	showinfo(params, fn) {
	 	commons(api.showinfo, params, fn)
	 },
	createdshow(params) {
		return sendPost(api.createdshow, params)
	},
	showrecall(params) {
		return sendPost(api.showrecall, params)
	},
	grouplist(params) {
		return sendPost(api.grouplist, params)
	},
	addgroup(params) {
		return sendPost(api.addgroup, params)
	},
	groupsort(params) {
		return sendPost(api.groupsort, params)
	},
	groupremove(params) {
		return sendPost(api.groupremove, params)
	},
}
